import {ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output} from '@angular/core';
import {DrawerItem, DrawerSelectEvent,} from "@progress/kendo-angular-layout";
import {NavigationEnd, Router} from '@angular/router';
import {CldrIntlService, IntlService} from '@progress/kendo-angular-intl';
import {TranslateService} from "@ngx-translate/core";
import {environment} from "../environments/environment";
import {RegPerziuraService} from "./service/reg-perziura.service";
import {LanguageService} from "./service/language.service";
import {chartAreaStackedIcon, clipboardTextIcon, logoutIcon, trackChangesIcon} from '@progress/kendo-svg-icons';
import {SharedDataService} from "./service/shared-data.service";
import {Observable} from "rxjs";
import {SessionTimerService} from "./service/session-timer.service";
import {UserDataApi} from "./api/user-data.api";
import {AtaskPerziuraService} from './service/atask-perziura.service';

@Component({
  selector: 'app-root',
  styleUrls: ['./app.component.css'],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  @Output() languageChanged: EventEmitter<string> = new EventEmitter<string>();
  title = 'gpais-internal-frontoffice';
  public icons = { logout: logoutIcon };
  currentLanguage: string = 'lt';
  userData!: UserDataApi;
  remainingTime$!: Observable<number>;
  sessionExpired$!: Observable<boolean>;

  public menuItems: Array<DrawerItem>;
  private gpaisInternalUrl = environment.gpaisInternalUrl;
  private menuTranslationMap: { [key: string]: string } = {
    'gii-registracija': 'menu.registracija',
    'gii-apskaita': 'menu.apskaita',
    'klasifikatorius': 'menu.klasifikatorius',
  };

  constructor(private router: Router,
              public intlService: IntlService,
              private translateService: TranslateService,
              public regPerziuraService: RegPerziuraService,
              private languageService: LanguageService,
              public sharedDataService: SharedDataService,
              private sessionTimerService: SessionTimerService,
              public ataskPerziuraService: AtaskPerziuraService) {

    this.userData = this.sharedDataService.getUserData();

    this.menuItems = [
      { text: 'GII registracija', svgIcon: trackChangesIcon, id: 'gii-registracija'},
      { separator: true },
      { text: 'GII apskaita', svgIcon: chartAreaStackedIcon, id: 'gii-apskaita' },
      { separator: true },
      { text: 'Klasifikatorius', svgIcon: clipboardTextIcon, id: 'klasifikatorius' },
    ];
  }

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const pathParts = window.location.pathname.split('/');
        const menuItemId = pathParts[1];
        this.menuItems.forEach(item => {
          item.selected = item.id === menuItemId;
        });
        this.menuItems = [...this.menuItems];
      }
    });
    this.currentLanguage = localStorage.getItem('appLanguage') || 'lt';
    this.translateMenuItems();
    this.sessionExpired$ = this.sharedDataService.getSessionExpired();
    this.remainingTime$ = this.sessionTimerService.getRemainingTime();
  }

  public onSelect(event: DrawerSelectEvent): void {
    const selectedItem = event.item as DrawerItem;
    if (selectedItem.id) {
      this.router.navigate([selectedItem.id]);
    }
  }

  toggleLanguage() {
    this.currentLanguage = this.currentLanguage === 'lt' ? 'en' : 'lt';
    localStorage.setItem('appLanguage', this.currentLanguage);
    this.languageService.setLanguage(this.currentLanguage);
    this.translateMenuItems();
    this.languageChanged.emit(this.currentLanguage);
    (<CldrIntlService>this.intlService).localeId = this.currentLanguage === 'lt' ? 'lt-LT' : 'en-US';
  }

  redirectToGpais() {
    window.location.href = this.gpaisInternalUrl;
  }

  private translateMenuItems() {
    this.menuItems.forEach((item) => {
      if (item.id) {
        this.translateService.get(this.menuTranslationMap[item.id]).subscribe((translatedText) => {
          item.text = translatedText;
        });
      }
    });
  }

  formatTime(seconds: number): string {
    const pad = (val: number): string => (val < 10 ? `0${val}` : `${val}`);

    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
  }

  closeSessionExpired(): void {
    this.sharedDataService.setSessionExpired(false);
  }

  pratestiSesija(): void {
    this.sessionTimerService.extendSession();
    const timeout = this.sharedDataService.getSessionTimeout();
    this.sessionTimerService.resetSessionTimer(timeout);
  }

}
